import { useContext, useEffect, useState } from "react";
import MultiSelectInput from "../../../layouts/ui/MultiSelectInput";
import InputRegister from "../../../layouts/ui/InputRegister";
import PreferrenceJson from "../../../data/skills.json";
import { validatePreferredJobForm } from '../../../utils/validator'
import { perferredDetails } from "../../../services/Candidate Portal/Profile/perferredDetails";
import { Layout } from "./Layout";
import { DataProvider } from "../../../store/ContextProvider"
import SelectInput from "../../../layouts/ui/SelectInput";
import { useLocation, useNavigate } from "react-router-dom";

export const Preferences = ({ candidate, fetchCandidateData }) => {
  const { BeURL ,currentUser } = useContext(DataProvider)
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    preferredJobRole: [],
    preferredJobLocations: [],
    employmentType: [],
    preferredWorkMode: [],
    currentCTC: "",
    expectedCTC: "",
    noticePeriod: "",
    negotiableNoticePeriod: ""
  });
  const [errors, setErrors] = useState({});

  // fetch the query:;

  const location = useLocation()
  const queryFetch = new URLSearchParams(location.search)
  const reverse = queryFetch.get('inverse') === "true"
  const previous = location.state?.from || '/account'


  useEffect(() => {
    fetchCandidateData()
  }, [])

  useEffect(() => {
    if (candidate) {
      setFormData({
        preferredJobRole: [...(candidate.preferredJob || [])],
        preferredJobLocations: [...(candidate.preferredLocation || [])],
        employmentType: [...(candidate.employmentType || [])],
        preferredWorkMode: [...(candidate.preferredWorkMode || [])],
        currentCTC: candidate.currentCTC.amount || "",
        expectedCTC: candidate.expectedCTC.amount || "",
        noticePeriod: candidate.noticePeriod || "",
        negotiableNoticePeriod: candidate.negotiableNoticePeriod || "",
      });
    }
  }, [candidate]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear or update error on change
    const validationErrors = validatePreferredJobForm({
      ...formData,
      [name]: value,
    });
    setErrors(validationErrors);
  };

  const handleSubmit = () => {
    const validationErrors = validatePreferredJobForm(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      return;
    }
    perferredDetails({ BeURL, formData, currentUser, navigate, reverse, previous });
  };


  return (
    <Layout candidate={candidate}>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-4 mb-16">
        {/* Form Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-3">
          {/* Multi-select fields */}
          <MultiSelectInput
            label="Preferred Job Roles"
            mandatory
            name="preferredJobRole"
            value={formData.preferredJobRole}
            onChange={(e) => setFormData({ ...formData, preferredJobRole: e.target.value })}
            placeholder="Select your preferred job roles"
            options={PreferrenceJson.preferredJobRole}
            multiple
            error={errors.preferredJobRole}
          />
          <MultiSelectInput
            label="Preferred Job Locations"
            mandatory
            name="preferredJobLocations"
            value={formData.preferredJobLocations}
            onChange={(e) => setFormData({ ...formData, preferredJobLocations: e.target.value })}
            placeholder="Select your preferred job locations"
            options={PreferrenceJson.preferredJobLocations}
            multiple
            error={errors.preferredJobLocations}
          />

          <MultiSelectInput
            label="Employment Type"
            mandatory
            name="employmentType"
            value={formData.employmentType}
            onChange={(e) => setFormData({ ...formData, employmentType: e.target.value })}
            placeholder="Select employment type"
            options={PreferrenceJson.EmploymentType}
            multiple
            error={errors.employmentType}
          />

          <MultiSelectInput
            label="Preferred Work Mode"
            mandatory
            name="preferredWorkMode"
            value={formData.preferredWorkMode}
            onChange={(e) => setFormData({ ...formData, preferredWorkMode: e.target.value })}
            placeholder="Select work mode"
            options={PreferrenceJson.PreferredWorkMode}
            multiple
            error={errors.preferredWorkMode}
          />

          {/* Text inputs */}
          <InputRegister
            label="Current CTC (LPA)"
            mandatory
            name="currentCTC"
            value={formData.currentCTC}
            onChange={(e) => handleChange("currentCTC", e.target.value)}
            placeholder="Enter current CTC"
            type="number"
            className={"w-full"}
            error={errors.currentCTC}
          />

          <InputRegister
            label="Expected CTC (LPA)"
            mandatory
            name="expectedCTC"
            value={formData.expectedCTC}
            onChange={(e) => handleChange("expectedCTC", e.target.value)}
            placeholder="Enter expected CTC"
            type="number"
            className={"w-full"}
            error={errors.expectedCTC}
          />
          <SelectInput
            label="Notice Period"
            mandatory
            value={formData.noticePeriod}
            name="noticePeriod"
            onChange={(e) => handleChange("noticePeriod", e.target.value)}
            options={PreferrenceJson.NoticePeriod}
            placeholder="Select notice period"
            error={errors.noticePeriod}
            className={"w-full"}
          />

          <SelectInput
            label="Negotiable Notice Period"
            value={formData.negotiableNoticePeriod}
            name="negotiableNoticePeriod"
            onChange={(e) => handleChange("negotiableNoticePeriod", e.target.value)}
            placeholder="Select negotiable notice period"
            options={PreferrenceJson.NegotiableNoticePeriod}
            error={errors.negotiableNoticePeriod}
            className={"w-full"}
          />
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 w-full">
          {/* Back Button */}
          <button onClick={() => navigate(`/update-account/highlights?userId=${currentUser?._id}`)} className="w-full sm:w-auto border border-primary-400 text-primary-400 px-4 py-2 rounded-xl font-medium hover:bg-primary-50 transition text-center">
           Previous
          </button>

          {/* Complete Button */}
          <button
            type="button"
            onClick={handleSubmit}
            className="w-full sm:w-auto bg-[#2C25C4] text-white px-4 py-2 rounded-xl font-semibold shadow-md hover:opacity-90 transition text-center"
          >
            {reverse ? 'Update' : ' Complete'}
          </button>
        </div>
      </section>
    </Layout>
  );
};
